<template>
  <v-card>
    <v-form
      lazy-validation
      ref="form"
      v-model="validForm"
      @submit.prevent="onConfirm"
    >
      <v-card-title primary-title>
        Skapa underkategori
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              :rules="[validationRules.required]"
              v-model="model.name"
              label="Underkategori"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              item-text="name"
              item-value="uuid"
              :items="Object.values(categoryGroups)"
              v-model="model.category_group_uuid"
              label="Kategorigrupp"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose">
          Avbryt
        </v-btn>
        <v-btn type="submit" color="primary" text>
          Spara
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import CREATE_CATEGORY from '@/gql/categories/mutations/CreateCategory.gql'
import { validationRules } from '@/common/validationRules'
import { v4 as uuid } from 'uuid'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataSubCategoriesCreate',

  data() {
    return {
      validationRules,
      validForm: true,
      model: {
        uuid: uuid(),
        name: '',
        category_group_uuid: null,
      },
    }
  },

  computed: {
    categoryGroups: get('categoryGroups/data'),
  },

  methods: {
    async onConfirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.createCategory()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    createCategory() {
      return this.$apollo.mutate({
        mutation: CREATE_CATEGORY,
        variables: {
          payload: this.model,
        },

        update: (store, { data }) => {
          this.$store.set('categories/data', {
            ...this.$store.get('categories/data'),
            [data.createCategory.uuid]: data.createCategory,
          })
        },
      })
    },
  },
}
</script>
